import styled from "styled-components"
import ButtonLink from "../btn-collections/btn-collections.component"
import tick from "../../svg/LightCheck.svg"
import { GatsbyImage } from "gatsby-plugin-image"

export const CareerPathCardContainer = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  grid-column: span 4;
  position: relative;
  box-shadow: 2px 4px 40px rgba(19, 15, 235, 0.1);
  border-radius: 3px;
  background: #fff;

  @media screen and (max-width: 1280px) {
    grid-column: span 6;
  }
  @media screen and (max-width: 760px) {
    grid-column: span 12;
  }
`
CareerPathCardContainer.displayName = "CareerPathCardContainer"

export const PathImage = styled(GatsbyImage)`
  border-radius: 3px 3px 0 0;
  img {
    border-radius: 3px 3px 0 0;
  }
`

export const CardContent = styled.div`
  padding: 25px;
  padding-bottom: 0;
  height: 100%;
`

export const CardTitle = styled.a`
  ${({ theme: { typography } }) => typography.desktop.h5};
  cursor: pointer;
  text-decoration: none;

  @media screen and (max-width: 760px) {
    ${({ theme: { typography } }) => typography.mobile.h6};
  }
`

export const Excerpt = styled.p`
  ${({ theme: { typography } }) => typography.desktop.excerpt};

  @media screen and (max-width: 760px) {
    ${({ theme: { typography } }) => typography.mobile.excerpt};
  }
`

export const ButtonContainer = styled.div`
  padding: 25px;
  padding-top: 20px;
`
export const PathButtonLink = styled(ButtonLink)`
  width: 100%;
`

export const MilestonesContainer = styled.div`
  ${({ theme: { typography } }) => typography.desktop.metadata};
  margin-top: 20px;
  margin-bottom: 20px;

  & span {
    font-size: 18px;
    color: ${({ theme: { colors } }) => colors.accentBlue};
    margin: 0 8px;
  }

  @media screen and (max-width: 760px) {
    ${({ theme: { typography } }) => typography.mobile.metadata};
    margin-top: 15px;
  }
`

export const TickIcon = styled(tick)`
  width: 15px;
  margin-right: 10px;
`
